// Angular + External
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
// BFX
import { BfxAuthService } from "../bfx-common/services/bfx-auth.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

export const DEFAULT_CONTEXT_PATH: string = "/";

@Component({
  selector: "bfx-logout",
  templateUrl: "./html/logout.component.html",
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class LogoutComponent implements OnInit {
  isNativeDesktop: boolean = false;

  public get frameTag() {
    return document.body.dataset.frameTag;
  }

  constructor(
    private _authService: BfxAuthService,
    private _router: Router,
  ) {
    this.isNativeDesktop = NativeDesktopSupport.isNativeDesktopContainer();
  }

  ngOnInit(): void {
    if (module["hot"]) {
      logger.out.info("HMR");
      return;
    }

    if (this._authService.isAuthenticated()) {
      this._authService.logout();
    }
  }

  public reroute(): void {
    let contextPath: string = this._authService.getSSOContextPath();

    if (contextPath == null || contextPath.trim().length == 0) {
      contextPath = DEFAULT_CONTEXT_PATH;
    }

    window.location.replace(contextPath);
  }
}
